var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"chat-scroll",rawName:"v-chat-scroll"}],staticClass:"chat-mensagens-lista scroll-y scroll-y-transition-enter-active overflow-x-hidden px-2"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }